import { render, staticRenderFns } from "./account-deleted.view.html?vue&type=template&id=9309c970&"
import script from "./account-deleted.vue?vue&type=script&lang=ts&"
export * from "./account-deleted.vue?vue&type=script&lang=ts&"
import style0 from "./account-deleted.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports